exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.countingBadges .v-badge__badge {\n    inset: auto auto calc(100% - 8px) calc(100% - 11px) !important;\n    font-size: 10px;\n    height: 13px;\n    padding: 2px 0px 1px 1px;\n    min-width: 13px;\n}\n\n", ""]);
